/**
 * 项目默认配置项
 * primaryColor - 默认主题色, 如果修改颜色不生效，请清理 localStorage
 * navTheme - sidebar theme ['dark', 'light'] 两种主题
 * colorWeak - 色盲模式
 * layout - 整体布局方式 ['sidemenu', 'topmenu'] 两种布局
 * fixedHeader - 固定 Header : boolean
 * fixSiderbar - 固定左侧菜单栏 ： boolean
 * autoHideHeader - 向下滚动时，隐藏 Header : boolean
 * contentWidth - 内容区布局： 流式 |  固定
 * storageOptions: {} - Vue-ls 插件配置项 (localStorage/sessionStorage)
 */

export default {
  primaryColor: "#13C2C2", // 默认主题色
  navTheme: "light", // 菜单主题
  layout: "topmenu", // 菜单位置: sidemenu or topmenu
  contentWidth: "Fixed",
  fixedHeader: true,
  fixSiderbar: false,
  autoHideHeader: false,
  colorWeak: false,
  multiTab: false,
  production: process.env.NODE_ENV === "production" ? true : false,
  storageOptions: {
    namespace: process.env.NODE_ENV === "production" ? "pro__" : "dev__", // key prefix
    name: "ls", // name variable Vue.[ls] or this.[$ls],
    storage: "local" // storage name session, local, memory
  }
};
